// extracted by mini-css-extract-plugin
module.exports = {"root":"Timestamp-root-1482bbb1138648119e6709b8049527fb"};